import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const FreeToiletriesIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "FreeToiletriesIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M17.3162 5.60957H16.6108V3.70736C16.6108 3.43757 16.3917 3.21814 16.1219 3.21814H13.7337C13.4642 3.21814 13.2451 3.43757 13.2451 3.70736V5.60957H12.5397C12.2703 5.60957 12.0512 5.829 12.0508 6.09878V20.652C12.0508 20.9217 12.27 21.1415 12.5397 21.1415H17.3162C17.5856 21.1415 17.8051 20.9221 17.8051 20.652V6.09839C17.8051 5.8286 17.5856 5.60957 17.3162 5.60957ZM14.2226 5.60957V4.19657H15.6333V5.60957H14.2226ZM16.8272 6.588V20.1624H13.0287V6.588H16.8272Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M22.093 8.00077H19.7048C19.4353 8.00077 19.2162 8.2202 19.2158 8.48998C19.2158 8.75977 19.4349 8.9792 19.7048 8.9792H21.6041V9.19628H19.7048C19.4353 9.19628 19.2162 9.41571 19.2158 9.6855C19.2158 9.95527 19.4349 10.1751 19.7048 10.1751H21.6041V10.3922H19.7048C19.4353 10.3922 19.2162 10.6116 19.2158 10.8814C19.2158 11.1512 19.4349 11.371 19.7048 11.371H21.6041V11.5881H19.7048C19.4353 11.5881 19.2162 11.8075 19.2158 12.0773C19.2158 12.3471 19.4349 12.5669 19.7048 12.5669H21.6041V20.6521C21.6041 20.9219 21.8232 21.1417 22.093 21.1417C22.3624 21.1417 22.5816 20.9223 22.5816 20.6521V8.48959C22.5816 8.2198 22.362 8.00116 22.093 8.00077Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M6.56976 18.825C7.13514 18.825 7.64358 18.4685 8.0023 17.8208C8.31033 17.264 8.48034 16.5347 8.48034 15.7666C8.48034 14.9987 8.31073 14.2694 8.0023 13.7126C7.64358 13.0652 7.13475 12.7084 6.56976 12.7084C6.00477 12.7084 5.49594 13.0648 5.13722 13.7126C4.8288 14.2694 4.65918 14.9987 4.65918 15.7666C4.65918 16.5347 4.82879 17.264 5.13722 17.8208C5.49594 18.4681 6.00439 18.825 6.56976 18.825ZM5.63397 15.7666C5.63397 14.5942 6.13696 13.6844 6.56976 13.6844C6.77837 13.6844 7.01036 13.9008 7.1905 14.2627C7.39365 14.6715 7.50555 15.2052 7.50555 15.7663C7.50555 16.9388 7.00256 17.8484 6.56976 17.8484C6.36115 17.8484 6.12916 17.6322 5.94902 17.2702C5.74587 16.8614 5.63397 16.3277 5.63397 15.7666Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M8.76093 10.392H4.37753C3.34153 10.392 2.49854 11.2361 2.49854 12.2739V19.2592C2.49854 20.297 3.34153 21.1411 4.37753 21.1411H8.76093C9.79735 21.1411 10.6403 20.297 10.6403 19.2592V12.2739C10.6403 11.2365 9.79735 10.392 8.76093 10.392ZM3.47605 12.2739C3.47605 12.0283 3.56846 11.8003 3.73651 11.632C3.90456 11.4637 4.13227 11.3708 4.37753 11.3708H8.76093C9.26664 11.3708 9.6628 11.7675 9.6628 12.2739V19.2592C9.6628 19.7656 9.26664 20.1623 8.76093 20.1623H4.37753C3.87181 20.1623 3.47605 19.7656 3.47605 19.2592V12.2739Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default FreeToiletriesIcon;
